import WizardTransition from "./WizardTransition";
import React from "react";
import useWizard from "./useWizard";

export default ({className, children, style}) => {
    const {stepPaths, currentStepPath, stepsMap} = useWizard();

    return <>
        {stepPaths[currentStepPath].map(({key}, stepIndex) => {
            return <WizardTransition renderedIndex={stepIndex} renderedStep={key} className={className} style={style} key={key}>
                {children(stepsMap[key])}
            </WizardTransition>
        })}
    </>
};

